import React from 'react';
import { Pills, Pill, Icon, Link, UtilsBlock } from '@hz-design-system/web-ui';

import { FILTERS } from '../constants';
import Classes from './SearchFeed.module.scss';

type TFilterPillsProps = {
  pageKey: string;
  isInApp: boolean;
  l1Filters: any[];
  l2Filters: any[];
  searchFilters: any[];
  searchLink?: string;
  modelFilter: Record<string, any>;
  filterRef: React.RefObject<HTMLDivElement | null>;
  toggleFilter: (event: any, type: any, categoryId: any, attributeGroup?: any) => void;
  goToSearch: () => void;
};

const FilterPills = ({
  pageKey,
  isInApp,
  l1Filters,
  l2Filters,
  searchFilters,
  searchLink,
  modelFilter,
  filterRef,
  toggleFilter,
  goToSearch,
}: TFilterPillsProps) => {
  return (
    <>
      <div className={Classes.filterRef} ref={filterRef} />
      <section className={Classes.filters}>
        <Pills className={Classes.pillsContainer}>
          {FILTERS[pageKey]?.includes('price') && (
            <Pill
              className={Classes.reversePill}
              onClick={(e) => toggleFilter(e, 'price', 'price')}
              translations={{
                ariaLabelDefault: 'Prijs filter',
                ariaLabelActive: 'Prijs filter actief',
              }}
            >
              Prijs
            </Pill>
          )}
          {Boolean(l1Filters.length) && FILTERS[pageKey]?.includes('l1') && (
            <Pill
              className={Classes.reversePill}
              onClick={(e) => toggleFilter(e, 'l1', 0)}
              translations={{
                ariaLabelDefault: 'Speelgoed filter',
                ariaLabelActive: 'Speelgoed filter actief',
              }}
            >
              {Boolean(l1Filters.length) && <span className={Classes.filterCounter}>{l1Filters.length}</span>}
              Speelgoed
            </Pill>
          )}
          {l1Filters.length < 1 && FILTERS[pageKey]?.includes('l1') && (
            <Pill
              className={Classes.reversePill}
              onClick={(e) => toggleFilter(e, 'l1', 0)}
              translations={{
                ariaLabelDefault: 'Categorie filter',
                ariaLabelActive: 'Categorie filter actief',
              }}
            >
              {Boolean(l1Filters.length) && <span className={Classes.filterCounter}>{l1Filters.length}</span>}
              Categorie
            </Pill>
          )}
          {Boolean(searchFilters) &&
            searchFilters.map((filter) => (
              <Pill
                key={filter.key}
                className={Classes.reversePill}
                onClick={(e) => toggleFilter(e, filter.key, filter.key, filter.attributeGroup)}
                translations={{
                  ariaLabelDefault: filter.label || '',
                  ariaLabelActive: filter.label || '',
                }}
              >
                {filter.label}
              </Pill>
            ))}
          {Boolean(Object.keys(modelFilter).length) && (
            <Pill
              className={`${Classes.reversePill} ${Classes.modelFilter}`}
              onClick={(e) => toggleFilter(e, 'model', 'model')}
              translations={{
                ariaLabelDefault: 'Model filter',
                ariaLabelActive: 'Model filter actief',
              }}
            >
              Model
            </Pill>
          )}
          {l1Filters.map((l1) => {
            const activeFilterCount = l2Filters.filter(({ groupId }) => groupId === l1.value).length;

            return (
              <Pill
                key={l1.id}
                className={Classes.reversePill}
                onClick={(e) => toggleFilter(e, 'l1', Number(l1.value))}
                translations={{
                  ariaLabelDefault: l1.labelText || '',
                  ariaLabelActive: l1.labelText || '',
                }}
              >
                {Boolean(activeFilterCount) && <span className={Classes.filterCounter}>{activeFilterCount}</span>}
                {l1.labelText}
              </Pill>
            );
          })}
          {!isInApp && pageKey === 'car-upgrade' && (
            <div className={Classes.fullSearchLink}>
              <Link onClick={goToSearch}>
                <Icon name="arrow-right-regular" color="action" />
                Alle filters
              </Link>
            </div>
          )}
        </Pills>
        {searchLink && (
          <UtilsBlock as="div" p="s" className={Classes.searchLink}>
            <Link href={searchLink} iconRight="external-link">
              Bekijk al het aanbod
            </Link>
          </UtilsBlock>
        )}
      </section>
    </>
  );
};

export default FilterPills;
